import React from 'react';
import Link from 'gatsby-link'
import PropTypes from 'prop-types';
import GridItem from '../components/GridItem';


const IndexPage = ({
  data: {
    caseStudies: { edges },
  },
}) => (

    <React.Fragment>
         <div className="blog-index">
             <div className="blog-index__wrapper">
              {edges.map(c => (
                <GridItem
                  uid={c.node.uid}
                  key={c.node.uid}
                  sizes={c.node.data.header_image.localFile.childImageSharp.sizes}
                  alt={c.node.data.title.text}
                  title={c.node.data.title.text}
                  subtitle={c.node.data.subtitle.text}
                  words={c.node.data.words.text}
                  category={c.node.data.category.text}
                  location={c.node.data.location.text}
                  date={c.node.data.date}
                />
              ))}
            </div>
          </div>
  </React.Fragment>

);

export default IndexPage;

IndexPage.propTypes = {
  data: PropTypes.shape({
    caseStudies: PropTypes.shape({
      edges: PropTypes.array.isRequired,
    }),
  }).isRequired,
};

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query IndexQuery {
    caseStudies: allPrismicCaseStudy(sort: { fields: [first_publication_date], order: DESC }) {
      edges {
        node {
          uid
          data {
            header_image {
              localFile {
                childImageSharp {
                  sizes(maxWidth: 940, maxHeight: 700, quality: 100, cropFocus: ENTROPY) {
                    ...GatsbyImageSharpSizes_noBase64
                  }
                }
              }
            }
            title {
              text
            }
            subtitle {
              text
            }
            words {
              text
            }
            category {
              text
            }
            location {
              text
            }
            date(formatString: "MMMM YYYY")
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx